import React, { useMemo } from "react"
import { Typography, Box, makeStyles } from "@material-ui/core"
import { DATE_PICKER_FORMAT } from "../../utils"
import { useSelector } from "react-redux"
import moment from "moment"
import { useTranslation } from "react-i18next"
import useUser from "../../utils/customHooks/useUser"

const useStyles = makeStyles((theme) => ({
	item: {
		marginBottom: 10,
	},
	color: {
		width: 14,
		minWidth: 14,
		height: 14,
		borderRadius: 3,
		marginRight: 9,
	},
	heading: {
		color: theme.palette.grey["D100"],
	},
	description: {
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		width: 400,
	},
}))

const EventDetails = ({ event }) => {
	const classes = useStyles()
	const [t] = useTranslation("global")
	const { getUserNameById } = useUser()

	const userName = useMemo(() => getUserNameById(event.userid), [event.userid])

	return (
		<Box display="flex" alignItems="center">
			{/* <PersonIcon fontSize="large" /> */}
			<Box marginLeft={1}>
				<Box display="flex" alignItems="center" className={classes.item}>
					<Typography
						variant="body1"
						component="span"
						className={classes.heading}
						style={{ minWidth: 115, display: "inline-block" }}
					>
						{t("event.field.name")}:
					</Typography>
					<Box display="flex" alignItems="center">
						<div className={classes.color} style={{ backgroundColor: event.colour }}></div>
						<Typography variant="body1" color="primary">
							{event.name}
						</Typography>
					</Box>
				</Box>
				<Box display="flex" alignItems="center" className={classes.item}>
					<Typography
						variant="body1"
						component="span"
						className={classes.heading}
						style={{ minWidth: 115, display: "inline-block" }}
					>
						{t("event.field.startDate")}:
					</Typography>
					<Typography variant="body1" color="primary">
						{moment(event.start_date).format(DATE_PICKER_FORMAT)}
					</Typography>
				</Box>
				<Box display="flex" alignItems="center" className={classes.item}>
					<Typography
						variant="body1"
						component="span"
						className={classes.heading}
						style={{ minWidth: 115, display: "inline-block" }}
					>
						{t("event.field.endDate")}:
					</Typography>
					<Typography variant="body1" color="primary">
						{moment(event.end_date).format(DATE_PICKER_FORMAT)}
					</Typography>
				</Box>
				<Box display="flex" alignItems="center" className={classes.item}>
					<Typography
						variant="body1"
						component="span"
						className={classes.heading}
						style={{ minWidth: 115, display: "inline-block" }}
					>
						{t("event.field.description")}:
					</Typography>
					<Typography variant="body1" color="primary" className={classes.description}>
						{event.description}
					</Typography>
				</Box>
				<Box display="flex" alignItems="center" className={classes.item}>
					<Typography
						variant="body1"
						component="span"
						className={classes.heading}
						style={{ minWidth: 115, display: "inline-block" }}
					>
						{t("event.field.createdBy")}:
					</Typography>
					<Typography variant="body1" color="primary">
						{userName}
					</Typography>
				</Box>
			</Box>
		</Box>
	)
}

export default EventDetails
